// check the support of NodeList.forEach()
// https://tips.tutorialhorizon.com/2017/01/06/object-doesnt-support-property-or-method-foreach/
(function () {
    if (typeof NodeList.prototype.forEach === "function") return false;
    NodeList.prototype.forEach = Array.prototype.forEach;
})();

// check if SVG is supported in the browser
(function () {
    // https://css-tricks.com/a-complete-guide-to-svg-fallbacks/
    function svgasimg() {
        return document.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#Image", "1.1");
    }

    if (svgasimg()) {
        let pngImages = document.querySelectorAll('img[data-process="png"]');

        pngImages.forEach(image => {
            let png = image.getAttribute('src');
            let svg = png.replace('.png', '.svg');
            image.setAttribute('src', svg);
            image.removeAttribute('srcset');
        });
    }
})();

// check if the browser is IE 10 or older
(function () {
    //Check the userAgent property of the window.navigator object
    var ua = window.navigator.userAgent;

    // IE 10 or older
    var msie = ua.indexOf('MSIE ');

    //IE 11
    // var trident = ua.indexOf('Trident/');

    if (msie > 0) {
        // var body = document.getElementsByTagName('body')[0];
        var message = document.createElement('div');
        message.setAttribute('id', 'outdated');
        message.innerHTML = '<p>You are using an old browser and the website may not work correctly. Consider changing your browser. <a href="https://www.microsoft.com/en-us/windowsforbusiness/end-of-ie-support" target="_blank" rel="external" title="Learn More">Learn More</a></p>';
        // body.insertBefore(message, body.firstChild);
        document.body.insertBefore(message, document.body.firstChild); // https://www.w3schools.com/jsref/dom_obj_body.asp
    }
})();

// alerts
(function () {
    let alert = document.querySelectorAll("p.alert");

    if (alert.length > 0) {
        alert.forEach(p => {
            setInterval(function () {
                p.classList.add('hidden');
            }, 5000);
        });
    }
})();